import { render, staticRenderFns } from "./ReleaseConceptContributorsV2.vue?vue&type=template&id=2685d231&"
import script from "./ReleaseConceptContributorsV2.vue?vue&type=script&lang=js&"
export * from "./ReleaseConceptContributorsV2.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseConceptContributorsV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports